export default function authorizationFailed(error) {
    return {
        type: authorizationFailed.type,
        payload: error,
    };
}

authorizationFailed.type = 'AUTHORIZATION_FAILED';
